import { render, staticRenderFns } from "./successContent.vue?vue&type=template&id=070edee6&scoped=true&"
import script from "./successContent.vue?vue&type=script&lang=js&"
export * from "./successContent.vue?vue&type=script&lang=js&"
import style0 from "./successContent.vue?vue&type=style&index=0&id=070edee6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070edee6",
  null
  
)

export default component.exports